module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/sale-2-a0c7888593cffbf7fe8def4589b999f8.svg";